<template>
  <div class="container">
    <el-card>
      <el-row style="height:40px;">
        <el-col :span="20">
          <el-form :inline="true" :model="searchParams">
            <el-form-item>
              <el-date-picker
                v-model="searchParams.time_range"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="timestamp"
                size="small" style="width: 400px">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select v-model="searchParams.production" size="small" placeholder="请选择环境"
                style="max-width: 120px">
                <el-option key="true" label="线上环境" :value="true"></el-option>
                <el-option key="false" label="测试环境" :value="false">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="IDFV/AndroidId" type="text" size="small"
                v-model="searchParams.device_id2" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="user_id" type="text" size="small" v-model="searchParams.user_id"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="searchParams.event_list" size="small" filterable clearable multiple
                placeholder="指定event">
                <el-option v-for="evt of events" :key="evt.event" :label="evt.event" :value="evt.event">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="check()">
                开始验收
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 15px" v-if="result.params">
      <el-descriptions class="margin-top" title="验收结果" :column="4" border v-if="result.params">
        <el-descriptions-item>
          <template slot="label">
            来源
          </template>
          <el-tag size="small">{{ result.params.production ? '正式环境': '测试环境' }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            时间范围
          </template>
          {{ result.params.start_time  + ' ~ ' + result.params.end_time }} 
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            设备ID
          </template>
          {{ result.params.device_id2 }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            用户ID
          </template>
          {{ result.params.user_id }}
        </el-descriptions-item>
        <el-descriptions-item :span="4">
          <template slot="label">
            事件
          </template>
          {{ result.params.event_list.join('、') }}
        </el-descriptions-item>
        <el-descriptions-item :span="4">
          <template slot="label">
            结果
          </template>
          <el-badge v-for="(ev, idx) of result.detail" :value="ev.count" class="item badge-item"
            :key="idx" :type="ev.badge_type">
            <el-button size="small" @click="changeEvent(ev.event)">{{ ev.event }}</el-button>
          </el-badge>
        </el-descriptions-item>
        <el-descriptions-item :span="4">
          <template slot="label">
            详情
          </template>
          <el-collapse v-model="activeEvent" @change="changeEvent" accordion style="width: 100%">
            <el-collapse-item v-for="(ev, idx) of result.detail" :title="ev.title" :name="ev.event"
              :key="idx" style="overflow: scroll">
              <el-table
                :data="ev.table_config.data"
                style="width: 100%"
                max-height="600">
                <el-table-column type='index'>
                </el-table-column>
                <el-table-column v-for="(col, idx) of ev.table_config.columns" :key="idx"
                  :prop="col.prop" :label="col.label" :width="col.width">
                </el-table-column>
              </el-table>
             
            </el-collapse-item>
          </el-collapse>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchParams: {
        production: false,
        time_range: [],
        device_id2: "",
        user_id: "",
        event_list: []
      },
      events: [],
      activeEvent: '',
      result: {}
    }
  },
  mounted() {
    let now = Date.now();
    this.searchParams.time_range = [ now - 3600 * 1000, now ];
    this.getEvents();
  },
  methods: {
    async getEvents() {

      let url =  `/etp/v1.0/event/list?app_id=${this.$store.state.appId}&status=-1`;
      let rst = await this.$http.get(url);

      let events  = rst.data.data;
      this.events = events;

    },
    async check() {

      let url = `/etp/v1.0/es/event/verify`;
      let params = JSON.parse(JSON.stringify(this.searchParams));

      params.app_id = this.$store.state.appId;
      params.start_timestamp  = params.time_range[0];
      params.end_timestamp    = params.time_range[1];

      let rst = await this.$http.post(url, params);
      this.parseResult(params, rst.data.data||[]);

    },
    genEventTableConfig(ev) {

      let event_name = ev.event;
      let total = ev.count;
      let key_count = Object.entries(ev.key_count || {});
      let extra_keys = Object.keys(ev.extra_key_count || {});
      let detail = ev.event_detail;

      let columns = [
        { label: 'time', prop: 'event_time' },
        { label: 'app_id', prop: 'app_id', width: 100 },
        { label: 'device_id', prop: 'device_id' },
        { label: 'user_id', prop: 'user_id', width: 100 },
      ];

      key_count.forEach(kc => {
        let [k, c] = kc;
        let icon = c == total ? '✔️' : '⚠️'
        let col = { label: `p.${k}(${icon})`, prop: `properties.${k}`};
        columns.push(col);
      })

      extra_keys.forEach(k => {
        let col = { label: `p.${k}(❓)`, prop: `properties.${k}`};
        columns.push(col)
      });

      let data = detail.map((d) => {
        return {
          event_time: this.ts2time(d.timestamp), app_id: d.info.app_id, app_version: d.info.app_version,
          device_id: d.info.device_id, user_id: d.info.user_id, properties: d.detail,
          event: event_name,
        }
      })

      return { columns, data }

    },
    validEvent(ev) {

      let miss = !Object.values(ev.key_count || {}).every((x) => x == ev.count);
      let extra = Object.keys(ev.extra_key_count || {}).length > 0;

      let t = [
        `【${ev.event}】`
      ]

      if (miss) {
        let mk = [];
        Object.entries(ev.key_count || {}).forEach((d) => {
          let [k, c] = d;
          if (c < ev.count) {
            mk.push(k)
          }
        })

        let head = mk.slice(0, 3);
        let n = `- ⚠️缺少已定义参数: ${head.join('、')}${mk.length > head.length ? '等': ''}`;
        t.push(n)
      }

      if (extra) {
        let ek = Object.keys(ev.extra_key_count);
        let head = ek.slice(0, 3);
        let n = `- ❓出现未定义参数: ${head.join('、')}${ek.length > head.length ? '等': ''}`;
        t.push(n)
      }

      let table_config = this.genEventTableConfig(ev);

      return {
        miss, extra, ...ev, badge_type: (miss || extra) ? 'danger': 'success',
        title: t.join(' '), table_config
      }

    },
    ts2time(ts) {
      let dt = new Date(ts);
      return dt.toLocaleString('sv', {timeZone: 'Asia/Shanghai'});
    },
    parseResult(params, events) {
      events.sort((x, y) => y.count - x.count)
      let rst = {};
      let warning = 0;

      events.forEach((ev) => {
        let r = this.validEvent(ev);
        rst[ev.event] = r;
        warning = warning + (r.miss || r.extra) ? 1: 0;
      })

      params.start_time = this.ts2time(params.time_range[0]);
      params.end_time = this.ts2time(params.time_range[1]);

      this.result = {
        params, total: events.length, warning: warning, detail: rst
      };

    },
    changeEvent(name) {
      this.activeEvent = name == this.activeEvent ? '': name;
    }
  }

}
</script>
<style lang="less" scoped>

.container {
  padding: 20px;
}

.content-box {
  min-height: 800px;
}

.badge-item {
  margin-top: 10px;
  margin-right: 20px;
}

</style>
